import { Injectable, NgZone } from '@angular/core';
import { ViewportRuler } from '@angular/cdk/overlay';
import { map } from 'rxjs/operators';

import { ElPlatform } from '../overlay/mapping';
import { ElLayoutRulerService } from '../../../services/ruler.service';
import { ElLayoutScrollService, ElScrollPosition } from '../../../services/scroll.service';


@Injectable()
export class ElViewportRulerAdapter extends ViewportRuler {
  constructor(platform: ElPlatform, ngZone: NgZone,
              protected ruler: ElLayoutRulerService,
              protected scroll: ElLayoutScrollService) {
    super(platform, ngZone);
  }

  getViewportSize(): Readonly<{ width: number; height: number; }> {
    let res;
    /*
    * getDimensions call is really synchronous operation.
    * And we have to conform with the interface of the original service.
    * */
    this.ruler.getDimensions()
      .pipe(map(dimensions => ({ width: dimensions.clientWidth, height: dimensions.clientHeight })))
      .subscribe(rect => res = rect);
    return res;
  }

  getViewportScrollPosition(): { left: number; top: number } {
    let res;
    /*
    * getPosition call is really synchronous operation.
    * And we have to conform with the interface of the original service.
    * */
    this.scroll.getPosition()
      .pipe(map((position: ElScrollPosition) => ({ top: position.y, left: position.x })))
      .subscribe(position => res = position);
    return res;
  }
}
